import React from 'react';
import { MessageCircle, Sparkles } from 'lucide-react';

// Mobile Chat Button Component (to be used under search)
const MobileChatButton = () => (
  <button
    onClick={() => window.dispatchEvent(new CustomEvent('openWineChat'))}
    className="md:hidden flex items-center justify-center gap-2 w-full py-3 bg-gradient-to-r from-[#722F37] to-[#8B3A42] text-white rounded-xl shadow-md hover:shadow-lg transition-all"
    data-testid="mobile-chat-btn"
  >
    <MessageCircle className="w-5 h-5" />
    <span className="font-medium">Ask Wine Sommelier</span>
    <Sparkles className="w-4 h-4" />
  </button>
);

export default MobileChatButton;
